import {
    deepMerge
} from '@antfu/utils'
import {
    createVuetify
} from 'vuetify'
import {
    VBtn
} from 'vuetify/components/VBtn'
import defaults from './defaults'
import {
    icons
} from './icons'
import {
    staticPrimaryColor,
    staticPrimaryDarkenColor,
    themes
} from './theme'

// Styles
import {
    cookieRef
} from '@/@layouts/stores/config'
import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

export default defineNuxtPlugin(nuxtApp => {
    const cookieThemeValues = {
        defaultTheme: resolveVuetifyTheme(),
        themes: {
            light: {
                colors: {
                    'primary': '#10AE97',
                    'primary-darken-1': '#0c806f',
                    'old-primary': '#8C57FF',
                    'old-primary-darken-1': '#8C57FF',
                },
            },
            dark: {
                colors: {
                    'primary': cookieRef('darkThemePrimaryColor', staticPrimaryColor).value,
                    'primary-darken-1': cookieRef('darkThemePrimaryDarkenColor', staticPrimaryDarkenColor).value,
                },
            },
        },
    }

    const optionTheme = deepMerge({
        themes
    }, cookieThemeValues)

    const vuetify = createVuetify({
        ssr: false,
        aliases: {
            IconBtn: VBtn,
        },
        defaults,
        icons,
        theme: optionTheme,
    })

    nuxtApp.vueApp.use(vuetify)
})